var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "atom",
    "data-name": "Atom",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".atom-cls-1{fill:#3aa2f2;}.atom-cls-2{fill:#45ff9a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-1",
    cx: 16.5,
    cy: 5.5,
    r: 4.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-1",
    cx: 7.5,
    cy: 21.5,
    r: 4.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-1",
    cx: 20.5,
    cy: 18.5,
    r: 4.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-2",
    cx: 21.5,
    cy: 10.5,
    r: 4.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-2",
    cx: 14.5,
    cy: 22.5,
    r: 4.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-2",
    cx: 4.5,
    cy: 16.5,
    r: 4.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-1",
    cx: 10.5,
    cy: 16.5,
    r: 4.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-2",
    cx: 10.5,
    cy: 4.5,
    r: 4.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-1",
    cx: 14.5,
    cy: 9.5,
    r: 4.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-1",
    cx: 4.5,
    cy: 9.5,
    r: 4.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-2",
    cx: 8.5,
    cy: 10.5,
    r: 4.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "atom-cls-2",
    cx: 15.5,
    cy: 14.5,
    r: 4.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtom);
export default __webpack_public_path__ + "static/media/Atom.64dfe3e5eded464859af4027e52a4832.svg";
export { ForwardRef as ReactComponent };